import { render, staticRenderFns } from "./BildirimCard.vue?vue&type=template&id=566bbed9&"
import script from "./BildirimCard.vue?vue&type=script&lang=js&"
export * from "./BildirimCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports